import { TextLink } from '@lux/text-link';
import { FunctionColor, Spacer } from '@lux/tokens';
import styled from 'styled-components';

export const CarouselContainer = styled.div`
    padding-bottom: ${Spacer.SM};
    padding-left: ${Spacer.SM};
    background: ${FunctionColor.function0};
`;

export const AfterTitleLink = styled(TextLink)`
    margin: 0 ${Spacer.S} ${Spacer.SM} ${Spacer.S};
    display: inline-block;
`;
